import { Component, Event, EventEmitter, h, Prop } from '@stencil/core';
import { SearchResultItem } from '../../../../domain/models/search'
import { CsvService } from '../../../../domain/services/csv.service'

@Component({
  tag: 'cr-professionals-bucket',
  styleUrl: 'cr-professionals-bucket.css',
  shadow: true,
})
export class CrProfessionalsBucket {

  @Prop() professionalDiscoveries: Array<SearchResultItem> = []

  @Event() removedDiscovery: EventEmitter<SearchResultItem>;

  render() {
    return (
      <div class="container">
        <div class="results">
          {
            this.professionalDiscoveries.map((discovery) =>
            <div class="result">
              <div class="descriptor">
                { `${discovery.displayName}` }
              </div>
              <div class="actions">
                <button
                  class="action-control"
                  title="Remove"
                  onClick={(e) => {this.handleRemoveAction(discovery, e)}}
                >
                  <cr-icon-xmark size="small" />
                </button>
              </div>
            </div>
            )
          }
        </div>
        <div class="bulk-actions">
          <bx-btn
            size="sm"
            kind="ghost"
            onClick={this.handleExportToCSV}
          >Export to CSV</bx-btn>
        </div>
      </div>
    )
  }

  private csvService: CsvService = new CsvService()

  private handleRemoveAction = (discovery: SearchResultItem, e: MouseEvent) => {
    e.preventDefault()
    this.removedDiscovery.emit(discovery)
  }

  private handleExportToCSV = (e: MouseEvent) => {
    e.preventDefault()
    const csv = `data:text/csv;charset=utf-8,${this.csvService.fromProfessionalDiscoveries(this.professionalDiscoveries)}`
    window.open(encodeURI(csv))
  }

}
